<template>
    <div class="board">
        <v-expansion-panels accordion>
            <v-expansion-panel v-for="(faq, index) in faqs" :key="index">
                <v-expansion-panel-header>
                    <p class="category mb-4 mb-lg-0">{{ faq.type }}</p>
                    <p class="tit-en font-size-16 font-size-lg-24 font-weight-bold color-primary">Q</p>
                    <p class="page-text font-weight-bold">{{ faq.subject }}</p>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <p class="tit-en page-text--sm font-weight-bold" style="color: #555">A</p>
                    <p class="page-text--sm" v-html="faq.content.replace(/\n/g, '<br>')" style="color: #777"></p>
                </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- S: 퍼블확인용 -->
            <!-- <v-expansion-panel>
                <v-expansion-panel-header>
                    <p class="category">{{ type }}</p>
                    <p class="icon"></p>
                    <p class="tit">FAQ 질문내용 입니다. FAQ 질문내용 입니다.FAQ 질문내용 입니다.FAQ 질문내용 입니다.FAQ 질문내용 입니다.FAQ 질문내용 입니다..FAQ 질문내용 입니다.</p>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <p class="icon"></p>
                    <p class="txt">FAQ 답변내용 입니다. FAQ 답변내용 입니다. FAQ 답변내용 입니다.FAQ 답변내용 입니다. FAQ 답변내용 입니다. FAQ 답변내용 입니다.</p>
                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <p class="category">개인정보문의</p>
                    <p class="icon"></p>
                    <p class="tit">FAQ 질문내용 입니다.</p>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <p class="icon"></p>
                    <p class="txt">
                        FAQ 답변내용 입니다. FAQ 답변내용 입니다. FAQ 답변내용 입니다.FAQ 답변내용 입니다. FAQ 답변내용 입니다. FAQ 답변내용 입니다. FAQ 답변내용 입니다. FAQ 답변내용 입니다. FAQ
                        답변내용 입니다.FAQ 답변내용 입니다. FAQ 답변내용 입니다. FAQ 답변내용 입니다.FAQ 답변내용 입니다. FAQ 답변내용 입니다. FAQ 답변내용 입니다.FAQ 답변내용 입니다. FAQ 답변내용
                        입니다. FAQ 답변내용 입니다.FAQ 답변내용 입니다. FAQ 답변내용 입니다. FAQ 답변내용 입니다.FAQ 답변내용 입니다. FAQ 답변내용 입니다. FAQ 답변내용 입니다.FAQ 답변내용 입니다. FAQ
                        답변내용 입니다. FAQ 답변내용 입니다.FAQ 답변내용 입니다. FAQ 답변내용 입니다. FAQ 답변내용 입니다.FAQ 답변내용 입니다. FAQ 답변내용 입니다. FAQ 답변내용 입니다.FAQ 답변내용
                        입니다. FAQ 답변내용 입니다. FAQ 답변내용 입니다.
                    </p>
                </v-expansion-panel-content>
            </v-expansion-panel> -->
            <!-- E: 퍼블확인용 -->
        </v-expansion-panels>
        <div class="mt-10">
            <p class="text-16 text-md-14 color-primary text-right">찾으시는 질문이 없으신 경우 1:1문의를 이용해 주시기 바랍니다.</p>
        </div>
    </div>
</template>

<script>
import api from "@/api";

export default {
    props: {
        code: { type: String, default: null },
    },
    data() {
        return {
            filter: {
                type: "회원서비스",
            },
            faqs: [],
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            try {
                await this.search();
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
        async search() {
            try {
                var { summary, faqs } = await api.v1.center.faqs.gets({
                    params: this.filter,
                });

                this.faqs = faqs;
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/styles/_mixins.scss";
@import "@/styles/_variables.scss";

$border-row: #e6e6e6;

.board {
    .v-expansion-panels {
        border-top: 2px solid #131313;
        border-bottom: 1px solid $border;
        border-radius: 0;
    }
    .v-expansion-panel:before {
        content: none;
    }
    .v-expansion-panel-header {
        min-height: 68px;
        padding: 16px 20px;
        .category {
            flex: 0 0 90px;
            height: 25px;
            line-height: 23px;
            text-align: center;
            font-size: 14px;
            color: #5b666e;
            border: 1px solid $border;
            border-radius: 0;
        }
        .tit-en {
            flex: 0 0 24px;
            position: relative;
            margin: 0 20px 0 24px;
        }
    }
    ::v-deep .v-expansion-panel-content__wrap {
        min-height: 170px;
        display: flex;
        padding: 20px 55px;
        background-color: #f7f8f9;
        border-top: 1px solid $border;
        .tit-en {
            position: relative;
            margin: 0 12px 0 0;
        }
    }
    ::v-deep .theme--light.v-expansion-panels .v-expansion-panel:not(:first-child):after {
        border-color: $border;
    }
    ::v-deep .theme--light.v-expansion-panels .v-expansion-panel-header .v-expansion-panel-header__icon .v-icon {
        font-size: 30px;
    }
    ::v-deep .theme--light.v-expansion-panels .v-expansion-panel-header--active .v-expansion-panel-header__icon .v-icon {
        color: $color-primary;
    }
}
@media (max-width: 1024px) {
    .board {
        .v-expansion-panel-header {
            min-height: unset;
            flex-direction: column;
            align-items: flex-start;
            padding: 10px 44px 10px 10px;
            .category {
                flex: 0 0 25px;
                width: 85px;
                font-size: 13px;
            }
            .tit-en {
                display: none;
            }
        }
        ::v-deep .v-expansion-panel-header__icon {
            position: absolute;
            top: 54px;
            right: 8px;
        }
        ::v-deep .v-expansion-panel-content__wrap {
            min-height: unset;
            padding: 10px;
            .tit-en {
                display: none;
            }
        }
        ::v-deep .v-expansion-panel-content__wrap {
            min-height: unset;
            padding: 10px;
            .txt {
                font-size: 14px;
            }
        }
    }
}
</style>
